import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AcquiredPage } from './acquired.page';

const routes: Routes = [
  {
    path: '',
    component: AcquiredPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AcquiredPageRoutingModule {}
